<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-reassign-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Reassign to Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Member</label>
                <input v-model="reassingMember.name" class="browser-default defaultModal-input" readonly type="text" />

              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Team</label>
                <select class="browser-default defaultModal-input" v-model="reassingMember.team_id">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(team, index) in defaultTeams" :key="index" :value="team.id">{{ team.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!reassignTeam"
            @click="doReassign()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Reassign
          </a>

          <a
            v-if="reassignTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Reassigning...
          </a>

          <a
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-add-member" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Add Member
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Account Name</label>
                <select class="browser-default defaultModal-input" v-model="memberData.id">
                  <option value="" selected>New Account</option>
                  <option v-for="(member, index) in getMemberWithTemporaryEmail" :key="index" :value="member.id">{{ $store.getters.formatFullName(member.last_name + ", ", member.first_name) }}</option>
                </select>
                <div class="defaultModal-helper-text">If the seller is registered in the old CRS, please select their name from the dropdown</div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="memberData.email" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required (Please enter a valid ALI email address)
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="addMember()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-edit-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Edit Team
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Primary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.primaryName"/>
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Secondary Name</label>
                <input class="browser-default defaultModal-input" type="text"  v-model="teamData.secondaryName"/>
                <div class="defaultModal-helper-text">
                  Optional (e.g. Team Hustle)
                </div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <input class="browser-default defaultModal-input" type="text" v-model="teamData.channel" readonly/>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Manager</label>
                <select class="browser-default defaultModal-input" v-model="teamData.manager">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(user, index) in getTeamUsers(teamData.id)" :key="index" :value="user.id">{{ user.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Monthly Target Group Referral</label>
                <input v-model="teamData.team_target_referrals" class="browser-default defaultModal-input" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Default Country</label>
                <select class="browser-default defaultModal-input" v-model="teamData.country">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(country, index) in defaultCountries" :key="index" :value="country.code">{{ country.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>

            </div>
          </form>

        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="editTeam()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->

      <div id="modal-assign-email" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Assign Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Account Name</label>
                <input v-model="assignEmailTo.name" class="browser-default defaultModal-input" readonly type="text" />
              </div>
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="assignEmailTo.email" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required (Please enter a valid ALI email address)
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!saving"
            @click="assignEmail()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Save
          </a>

          <a
            v-if="saving"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Saving...
          </a>

          <a
            href="javascript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>

    <div class="row dvQuickGlance forTeams">

      <div class="col s12 l7 row valign-wrapper dvQuickGlance-main">

        <div
          class="col dvQuickGlance-info valign-wrapper">
          <ImageUploader
            :photo="team.photo"
            :team_id="team.id"
            @replacePhoto="replacePhoto"></ImageUploader>
          <div class="dvQuickGlance-user">
            <div class="dvQuickGlance-user-channel"><span class="icon-fs_world"></span>{{ team.channel }}</div>
            <div class="dvQuickGlance-user-team">{{ team.team }}</div>
            <div class="dvQuickGlance-user-details">
              <div class="dvQuickGlance-user-details-label">Team name:</div>
              {{ team.team_name }}
            </div>
            <div class="dvQuickGlance-user-details">
              <div class="dvQuickGlance-user-details-label">Manager:</div>
              {{ team.manager }}
            </div>
          </div> <!-- dvQuickGlance-user -->
        </div> <!-- dvQuickGlance-info -->

        <div
          class="col dvQuickGlance-action">

          <router-link
            :to="{ name:'admin_team_member_resolve', params: { id: 'all', team_id: id, referral_id: 'all' } }"
            class="waves-effect waves-light btn-RoundCorners">
            <span class="icon-action_check_circle"></span><div class="label">Resolve All</div>
          </router-link>

          <a
            ref="tippy_main_menu"
            name="main-menu"
            class="waves-effect waves-dark btn-Menu-more flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

          <tippy
           to="main-menu"
           placement="bottom-end"
           offset="[10, 0]"
           interactive
           arrow
           trigger="click">
           <div class="morePopMenuBox-content ">
             <a
              @click="openModalTeam('modal-add-member')"
              href="javascript:void(0)" class="morePopMenuBox-content-item">
               <span class="icon-action_add"></span>Add Member
             </a>
             <a
              @click="openModalTeam('modal-edit-team')"
              href="javascript:void(0)" class="morePopMenuBox-content-item">
               <span class="icon-action_edit"></span>Edit Team
             </a>
           </div>
         </tippy>


        </div> <!-- dvQuickGlance-action -->

      </div> <!-- dvQuickGlance-main -->

      <div class="col s12 l5 dvQuickGlance-links">
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Valid<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgValid flexCenterAll">{{ summary.valid }}</div>
        </div> <!-- dvQuickGlance-link -->
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Pending<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgPending flexCenterAll">{{ summary.pending }}</div>
        </div> <!-- dvQuickGlance-link -->
        <div class="waves-effect waves-light dvQuickGlance-link">
          <div class="dvQuickGlance-link-label">Expiring<span class="icon-nav_link_right"></span></div>
          <div class="dvQuickGlance-link-count bgExpiring flexCenterAll">{{ summary.expiring }}</div>
        </div> <!-- dvQuickGlance-link -->
      </div>
    </div> <!-- dvQuickGlance -->

    <div class="row dvContent forTeams">

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_referrals"></span>Team Members ({{ pager.totalRecords }})
          </div> <!-- dvSectionTitleOpts-title -->
          <div class="dvSectionTitleOpts-options">
            <!-- <div class="waves-effect waves-light btn-Pill">
              <span class="icon-editor_list"></span>
              <div class="label">List</div>
            </div> -->
            <a
              id="show-add-member"
              @click="showAddMember()"
              href="javascript:void(0)" class="waves-effect waves-light btn-RoundCorners modal-trigger"><span class="icon-action_add_circle"></span><div class="label">Add Member</div></a>
            <a
              id="show-edit-team"
              href="#modal-edit-team" class="waves-effect waves-light btn-RoundCorners modal-trigger"><span class="icon-action_edit"></span><div class="label">Edit Team</div></a>

          </div> <!-- dvSectionTitleOpts-options -->
        </div> <!-- dvSectionTitleOpts -->

        <div class="dvCards-container">
          <div class="row">
            <div
              v-show="noRecordFound && !loading"
              class="col s12 dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                  <div class="dvBlankSection-text-primary center-align">
                    There are no team members to display
                  </div>
                  <div class="dvBlankSection-text-secondary center-align">
                    Try using the search box above to find what you are looking for.
                  </div>
                </div>
              </div>
            </div>

            <ContentLoader :loading="membersLoading" :firstLoad="firstLoad" v-if="true"></ContentLoader>

            <!-- <div
              v-show="membersLoading"
              class="col s12 dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-text-primary center-align">
                    Please wait...
                  </div>
                </div>
              </div>
            </div> -->

            <div
              v-for="(member, index) in members" :key="index"
              class="col s12 m12 l6 xl4">
              <div class="dvCardClient" :class="{ 'member-unassigned': $store.getters.isTemporaryEmail(member.email) }">
                <div class="dvCardClient-header" :class="{ 'dvCard-isArchive': member.status == 2 }">
                  <div class="dvCardClient-header-name">

                    <div class="dvCardProfile-image">
                      <div class="dvCardProfile-image-placer flexCenterAll">
                        <div>
                          <span class="icon-fs_user" v-show="!$store.getters.isTemporaryEmail(member.email)"></span>
                          <span class="icon-action_help" v-show="$store.getters.isTemporaryEmail(member.email)"></span>
                        </div>
                      </div>
                      <img class="dvCardProfile-image-pic responsive-img" :src="member.photo" v-show="member.photo && member.photo.length > 0"/>
                    </div>

                    <div class="dvCardClient-header-name-info">
                      {{ $store.getters.formatFullName(member.first_name, member.last_name) || member.email }}
                      <div class="dvCardClient-header-name-info-label">{{ member.position }}</div>
                    </div> <!-- dvCardClient-header-name-info -->
                  </div> <!-- dvCardClient-header-name -->

                  <div
                    class="dvCardClient-header-menu">

                    <a
                      :name="'card-box-menu-'+index"
                      :ref="'tippy_menu'+index"
                      class="waves-effect waves-light dvCardClient-header-link flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>

                    <tippy
                     v-bind:to="'card-box-menu-'+index"
                     placement="bottom-end"
                     offset="[10, 2]"
                     interactive
                     arrow
                     trigger="click">
                     <div class="morePopMenuBox-content" v-show="!$store.getters.isTemporaryEmail(member.email)">

                       <router-link
                         class="morePopMenuBox-content-item"
                         :to="{ name:'admin_team_member', params: { id: member.id, team_id: id, status: 'valid' } }">
                         <span class="icon-editor_view"></span>View
                       </router-link>

                       <router-link
                        v-if="member.pending > 0"
                         class="morePopMenuBox-content-item"
                         :to="{ name:'admin_team_member_resolve', params: { id: member.id, team_id: id, referral_id: 'all' } }">
                         <span class="icon-action_check"></span>Resolve
                       </router-link>

                       <a
                        @click="showReassignModal(member)"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">swap_horiz</i>Reassign to Team
                       </a>

                       <a
                        v-if="member.role == $getConstRole('ROLE_MANAGER')"
                        @click="confirm({
                         id: member.id,
                         type: 'remove-as-manager',
                         name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">cancel</i>Remove as Manager
                       </a>

                       <a
                        v-if="member.role == $getConstRole('ROLE_SELLER')"
                        @click="confirm({
                         id: member.id,
                         type: 'assign-as-manager',
                         name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <span class="icon-action_star"></span>Assign as Manager
                       </a>

                       <a
                        v-if="member.status == 2"
                        @click="confirm({
                         id: member.id,
                         type: 'activate-member',
                         name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">check_circle</i>Activate
                       </a>

                       <a
                        v-if="member.status == 1"
                        @click="confirm({
                         id: member.id,
                         type: 'disable-member',
                         name: $store.getters.formatFullName(member.first_name, member.last_name) || member.email
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">block</i>Disable
                       </a>

                       <a
                       @click="confirm({
                         id: member.id,
                         type: 'remove-member'
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">cancel</i>Remove
                       </a>

                       <a
                       @click="confirm({
                         id: member.id,
                         type: 'reset-password'
                       })"
                       href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">person</i>Reset Password
                       </a>

                       <a
                         @click="openModalAssignEmail(member)"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">person</i>Assign Email
                       </a>
                     </div>

                     <div class="morePopMenuBox-content" v-show="$store.getters.isTemporaryEmail(member.email)">
                       <a
                         @click="openModalAssignEmail(member)"
                         href="javascript:void(0)" class="morePopMenuBox-content-item">
                         <i class="material-icons">person</i>Assign Email
                       </a>
                     </div>

                   </tippy>

                  </div> <!-- dvCardClient-header-menu -->
                </div> <!-- dvCardClient-header -->
                <div class="dvCardClient-content">
                  <div class="dvCardClient-content-items">
                    <router-link
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'admin_team_member', params: { id: member.id, team_id: id, status: 'valid' } }">
                      <div>Valid</div>
                      <div class="dvCardClient-count bgValid">{{ member.valid }}</div>
                    </router-link>

                    <router-link
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'admin_team_member', params: { id: member.id, team_id: id, status: 'pending' } }">
                      <div>Pending</div>
                      <div class="dvCardClient-count bgPending">{{ member.pending }}</div>
                    </router-link>

                    <router-link
                      class="waves-effect waves-light dvCardClient-content-items-link"
                      :to="{ name:'admin_team_member', params: { id: member.id, team_id: id, status: 'expiring' } }">
                      <div>Expiring</div>
                      <div class="dvCardClient-count bgExpiring">{{ member.expiring }}</div>
                    </router-link>

                    <div v-show="!$store.getters.isTemporaryEmail(member.email)" class="dvCardClient-content-items-label"><span class="icon-content_activity"></span>{{ member.last_activity }}</div>
                    <div v-show="$store.getters.isTemporaryEmail(member.email)" class="dvCardClient-content-items-label"><span class="icon-action_help"></span>No assigned email</div>
                  </div> <!-- dvCardClient-content-items -->

                  <div
                    class="row dvCardClient-content-action">
                    <div class="col s12 m6">
                      <div
                        v-if="member.pending == 0"
                        class="waves-effect waves-light btn-RoundCorners isResolve isDisabled">
                        <div class="label">Resolve</div>
                      </div>
                      <router-link
                        v-if="member.pending > 0"
                        :to="{ name:'admin_team_member_resolve', params: { id: member.id, team_id: id, referral_id: 'all' } }"
                        href="javascript:void(0)"
                        class="waves-effect waves-light btn-RoundCorners isResolve">
                        <div class="label">Resolve</div>
                        <div class="dvCardClient-count">{{ member.pending }}</div>
                      </router-link> <!-- RoundCorners -->
                    </div> <!-- col -->
                    <div class="col s12 m6">
                      <a :href="'mailto:'+member.email" class="waves-effect waves-dark btn-RoundCorners"><span class="icon-content_email"></span><div class="label">Contact</div></a>
                    </div> <!-- col -->
                  </div> <!-- dvCardClient-content-action -->
                </div> <!-- dvCardClient-content -->
              </div> <!-- dvCardClient -->
            </div> <!-- col -->

          </div> <!-- row -->
        </div>
      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <a
            :disabled="(pager.currentPage < 2 || loading) ? true : false"
            @click="previousPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            <span class="icon-nav_chevron_left"></span>Previous
          </a>
<!--  -->
          <div class="dvContentTools-pagination">
            <form id="frmChangePassword" @submit.prevent="setPage">
              <input
                type="text" class="browser-default" v-model="pager.currentPage" />
            </form>
            <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
            <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
          </div>

          <a
            :disabled="!pager.hasNext || loading"
            @click="nextPage()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
            Next<span class="icon-nav_chevron_right"></span>
          </a>
        </div>
        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>
  </div>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import M from 'materialize-css'
  import ImageUploader from '@/components/admin/TeamImageUploader.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import printJS from 'print-js'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'teams-main',
    data: () => ({
      assignEmailTo: {
        id: '',
        name: '',
        email: ''
      },
      teamData: {
        id: '',
        primaryName: '',
        secondaryName: '',
        channel: '',
        manager: '',
        team_target_referrals: '',
        country: ''
      },
      reassignTeam: false,
      defaultTeams: [],
      defaultUsers: [],
      defaultChannels: [],
      defaultCountries: [],
      id: '',
      printSendTo: '',
      sendingPrint: false,
      loadedCnt: 0,
      firstLoad: true,
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      memberData: {
        id: '',
        team_id: '',
        email: ''
      },
      team_name: '',
      team_target_referrals: '',
      team: {},
      summary: {
        valid: '0',
        pending: '0',
        expiring: '0'
      },
      members: [],
      pager: {
        currentPage: 1,
        perPage: 9,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      sortPopMenuBox: '',
      orderBy: '',
      loading: false,
      noRecordFound: false,
      membersLoading: false,
      reassingMember: {
        id: '',
        name: '',
        team_id: ''
      },
      saving: false,
      domain: '',
    }),
    watch: {
      loadedCnt: function() {
        if(this.loadedCnt == 2){
          this.firstLoad = false
        }
      }
    },
    computed: {
      getMemberWithTemporaryEmail (){
        let members = this.members.filter(member => {
          return member.email.substr(member.email.length - 19) == '@tmpimportemail.com'
        })

        members = members.sort((a,b) => {
          let fa = a.last_name.toLowerCase(), fb = b.last_name.toLowerCase();
          if (fa < fb) {
            return -1
          }
          if (fa > fb) {
            return 1
          }
          return 0
        })

        return members
      },
    },
    methods: {
      showAddMember () {
        this.memberData = {
          id: '',
          team_id: '',
          email: ''
        }

        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById('modal-add-member');
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      resetPassword (member){
        this.$http.secured.post('/api/members/reset-password/'+ member)
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
      },
      getTeamUsers (team_id){
        let teamUsers = this.defaultUsers.filter(user => {
          return user.team_id == team_id
        })
        return teamUsers
      },
      doReassign () {
        if(this.reassignTeam){
          return false;
        }
        this.reassignTeam = true
        let self = this

        this.$http.secured.post('/api/members/reassign/'+ this.reassingMember.id + '/' + this.reassingMember.team_id)
          .then(response => {
            this.getTeamDetails()
            this.getMembers()
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-reassign-team')
            this.teamTomove = ''
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.reassignTeam = false
          })
      },
      showReassignModal (member) {
        let reassingMember = {
          id: member.id,
          name: this.$store.getters.formatFullName(member.first_name, member.last_name) || member.email,
          team_id: this.id
        }
        this.reassingMember = reassingMember
        this.openModalTeam('modal-reassign-team')
      },
      printJS (){
        printJS(this.domain+'/api/teams?request_type=print&team_id='+ this.id);
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = 'api/teams?team_id='+ this.id+'&request_type=mail&send_to='+this.printSendTo

        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      replacePhoto (photo){
        this.team.photo = photo
      },
      editTeam (){

        if(this.teamData.primaryName == ''){
          this.showMessage('The primary name field is required.', 'sb-failed')
          return false
        }

        if(this.teamData.team_target_referrals == ''){
          this.showMessage('The monthly target group referral field is required.', 'sb-failed')
          return false
        }

        if(this.saving){
          return false
        }

        let self = this
        self.saving = true
        let teamUpdate = {
          name: this.teamData.primaryName,
          team_name: this.teamData.secondaryName,
          team_target_referrals: this.teamData.team_target_referrals,
          manager_id: this.teamData.manager,
          country: this.teamData.country
        }

        let url = '/api/admin/teams/'+this.team.id

        this.$http.secured.put(url, teamUpdate)
          .then(response => {

            this.team.team = response.data.team
            this.team.manager = response.data.manager
            this.team.team_name = response.data.team_name
            this.team.team_target_referrals = response.data.team_target_referrals

            this.closeModal('modal-edit-team')
            this.showMessage('Team successfully updated', 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      addMember (){

        if(this.memberData.email == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.saving){
          return false
        }

        let self = this
        self.saving = true

        this.memberData.team_id = this.id

        this.$http.secured.post('api/members', this.memberData)
          .then(response => {
            this.closeModal('modal-add-member')
            if (response.data.success) {
              this.showMessage(response.data.message, 'sb-success')
            } else {
              this.showMessage('Member has been successfully registered. Email sent to ' + response.data.email, 'sb-success')
            }

            this.memberData.email = ''
            this.memberData.id = ''
            this.pager.currentPage = 1
            this.getMembers()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        let team_name = this.team.team_name
        this.team_name = team_name

        let team_target_referrals = this.team.team_target_referrals
        this.team_target_referrals = team_target_referrals

        this.memberData.email = ''
        this.printSendTo = ''
      },
      openModalTeam (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      assignEmail (){
        if(this.saving){
          return false
        }

        let self = this
        self.saving = true

        this.$http.secured.post('api/members/assign-email', this.assignEmailTo)
          .then(response => {
            this.closeModal('modal-assign-email')
            this.showMessage(response.data.message, 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })

              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.saving = false
          })
      },
      openModalAssignEmail (member){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        this.assignEmailTo.id = member.id
        this.assignEmailTo.name = this.$store.getters.formatFullName(member.first_name, member.last_name)

        this.assignEmailTo.email = ''

        if (!this.$store.getters.isTemporaryEmail(member.email)) {
          this.assignEmailTo.email = member.email
        }

        const elem = document.getElementById('modal-assign-email');
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'remove-member'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to remove this?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_delete',
            positionBtn: 'Remove',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'activate-member'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to activate '+action.name+'?',
            body: '',
            icon: 'check_circle',
            icon_material: true,
            positionBtn: 'Activate',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'disable-member'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to disable '+action.name+'?',
            body: '',
            icon: 'block',
            icon_material: true,
            positionBtn: 'Disable',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'remove-as-manager'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to remove '+action.name+' as manager?',
            body: '',
            icon: 'icon-action_delete',
            positionBtn: 'Remove',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'assign-as-manager'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to assign '+action.name+' as manager?',
            body: '',
            icon: 'icon-action_star',
            positionBtn: 'Assign',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type == 'reset-password'){
          this.dialog = {
            show: true,
            title: "Are you sure you want to reset the user's password?",
            body: '',
            icon: 'icon-fs_user',
            positionBtn: 'Reset',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }

      },
      doConfirm (){
        this.dialog.show = false
        if(this.dialog.actionType == 'remove-member'){
          this.processRemoveMember(this.dialog.id)
        }else if(this.dialog.actionType == 'disable-member'){
          this.processDisableMember(this.dialog.id)
        }else if(this.dialog.actionType == 'activate-member'){
          this.processActivateMember(this.dialog.id)
        }else if(this.dialog.actionType == 'remove-as-manager'){
          this.removeTeamManager(this.dialog.id)
        }else if(this.dialog.actionType == 'assign-as-manager'){
          this.assignAsTeamManager(this.dialog.id)
        }else if(this.dialog.actionType == 'reset-password'){
          this.resetPassword(this.dialog.id)
        }
      },
      assignAsTeamManager (){
        this.$http.secured.post('/api/admin/teams/assign-as-manager/'+ this.id+'/'+this.dialog.id)
          .then(response => {
            this.getTeamDetails()
            this.getMembers()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      removeTeamManager (){
        this.$http.secured.post('/api/admin/teams/remove-manager/'+ this.id)
          .then(response => {
            this.getTeamDetails()
            this.getMembers()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      processDisableMember (id){
        this.$http.secured.post('api/members/disable/'+ id)
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      processActivateMember (id){
        this.$http.secured.post('api/members/activate/'+ id)
          .then(response => {
            this.showMessage(response.data.message, 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      processRemoveMember (id){
        this.$http.secured.delete('api/members/'+ id)
          .then(response => {
            this.showMessage('Member has been successfully deleted', 'sb-success')
            this.getMembers()
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
      },
      setPage (){
        if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
          this.pager.currentPage = 1
        }

        this.getMembers();
      },
      previousPage (){
        this.pager.currentPage--;
        this.getMembers();
      },
      nextPage (){
        this.pager.currentPage++;
        this.getMembers();
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      getMembers () {
        if(this.membersLoading){
          return false;
        }

        window.scroll(0, 0)

        let self = this
        this.membersLoading = true
        this.noRecordFound = false
        this.selected = [];
        this.members = [];
        let url = '/api/members?team_id='+this.id+'&page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        this.$http.plain.get(url)
          .then(response => {

            this.members = response.data.members;

            if(this.members.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages
            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.membersLoading = false
            self.loadedCnt++
          })
      },
      getTeamDetails () {
        if(this.loading){
          return false;
        }

        let self = this
        this.loading = true
        let url = 'api/teams?team_id='+ this.id
        this.$http.plain.get(url)
          .then(response => {
            this.team = response.data.team
            this.summary = response.data.summary

            let team = this.team

            this.teamData = {
              id: this.id,
              primaryName: team.team,
              secondaryName: team.team_name,
              channel: team.channel,
              manager: team.manager_id,
              team_target_referrals: team.team_target_referrals,
              country: team.country
            }

          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.loadedCnt++
          })
      },
      getDefaultData () {
        this.$http.plain.get('api/default-data')
          .then(response => {
            this.defaultUsers = response.data.users
            this.defaultChannels = response.data.channels
            this.defaultTeams = response.data.teams
            this.defaultCountries = response.data.countries
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    mounted() {
      this.domain = this.$store.getters.getApiURL
      this.id = this.$route.params.id
      this.getTeamDetails()
      this.getMembers()
      this.getDefaultData()
      M.AutoInit()
      if(this.$route.query.removed){
        this.showMessage(this.$route.query.msg, 'sb-success')
      }
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      ImageUploader,
      BodyLoader,
      ContentLoader,
      ToTop
    }
  }
</script>
